import { DISMISS_GBQ_BANNER, GRADE_BY_QUESTION_ENABLED, GBQ_SET_ACTIVE_ITEM } from '@instructure/quiz-common';
export function setGradeByQuestionEnabled(enabled) {
  return {
    type: GRADE_BY_QUESTION_ENABLED,
    payload: enabled
  };
}
export function setActiveItem(itemId) {
  return {
    type: GBQ_SET_ACTIVE_ITEM,
    payload: itemId
  };
}
export function dismissGradeByQuestionBanner() {
  return {
    type: DISMISS_GBQ_BANNER
  };
}